export default __webpack_public_path__ + "static/media/calculator-moneystack2.62aead78.png";